<script lang="ts">
    
    import { Accordion } from "sveltestrap";
    import type { Form } from "../../Model/Form";
    import Watch from "../Watch.svelte";
    import SectionPreview from "./SectionPreview.svelte";

    export let form: Form;

</script>

<Accordion>
    <Watch store={form.sectionsReadable} let:value={sections}>
        {#each sections as section, index}
            <SectionPreview {section} position={index + 1} />
        {/each}
    </Watch>
</Accordion>


